/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statistics_Wentoutofstock3Inputs */

const he_statistics_wentoutofstock3 = /** @type {(inputs: Statistics_Wentoutofstock3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוצרים שאזלו מהמלאי`)
};

const en_statistics_wentoutofstock3 = /** @type {(inputs: Statistics_Wentoutofstock3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items went out of stock`)
};

/**
* | output |
* | --- |
* | "Items went out of stock" |
*
* @param {Statistics_Wentoutofstock3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const statistics_wentoutofstock3 = /** @type {((inputs?: Statistics_Wentoutofstock3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statistics_Wentoutofstock3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_statistics_wentoutofstock3(inputs)
	return en_statistics_wentoutofstock3(inputs)
});
export { statistics_wentoutofstock3 as "statistics_wentOutOfStock" }